<template lang="pug">
  .bg-footer
    .bg-footer-mail
      img.img-bg(:src="require($route.name=='home'?'@/assets/svg/footer-bg.svg':'@/assets/svg/footer-bg-branco.svg')")
      .center
        el-button.to-top.btn-custom-color(:class="$route.name=='home'?'':'white'", round, type="danger", icon="el-icon-top", @click="_toTop")
      .clear
      .center
        section.custom-width
          .margin-top
          el-row(:gutter="16")
            el-col(:xs="0", :sm="6", :md="6", :style="{opacity: 0}") .
            el-col(:xs="24", :sm="12", :md="12")
              h1.text-center Impulsione seu trabalho com a 2ED
              .center
                .box-field
                  input.custom-field(ref="field", placeholder="Seu e-mail", type="mail", v-model="email")
                  el-button.btn-custom.footer-btn(round, type="danger", @click="_validateEmail") Vamos lá
              el-col(:xs="0", :sm="6", :md="6", :style="{opacity: 0}") .
              .clear
              .margin-top
            el-col(:xs="24", :sm="8", :md="8", :style="{marginBottom: '16px'}")
              h5.text-secondary Telefones
              p 62 9.9370-4818
            el-col(:xs="24", :sm="8", :md="8", :style="{marginBottom: '16px'}")
              h5.text-secondary Email
              p contato@agencia2ed.com.br
            el-col(:xs="24", :sm="8", :md="8", :style="{marginBottom: '16px'}")
              h5.text-secondary Endereço
              p R. Nnnnn, Qd. AN, Lt. 13, Anápolis - GO
          .margin-top
    .center
      section.custom-width
        .margin-top
        el-row(:gutter="16")
          el-col(:xs="24", :sm="8", :md="8", :style="{marginBottom: '16px'}")
            img.logo(:src="require('@/assets/svg/logo-branca.svg')")
            p(:style="{marginBottom: '16px'}") Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque tortor massa, dictum eu dictum eget, ultricies eget nisl.
          el-col(:xs="0", :sm="4", :md="4", :style="{opacity: 0}") .
          el-col(:xs="12", :sm="4", :md="4", :style="{marginBottom: '16px'}")
            h5
              img.rocket(:src="require('@/assets/svg/foguete.svg')")
              |Empresa
            a(href="#", @click="_action({name: 'about'})") Sobre
            br
            a(href="#") Nossos clientes
          el-col(:xs="12", :sm="4", :md="4", :style="{marginBottom: '16px'}")
            h5
              img.rocket(:src="require('@/assets/svg/foguete.svg')")
              |Redes sociais
            a(href="#") Facebook
            br
            a(href="#") Instagram
            br
            a(href="#") YouTube
            br
            a(href="#") Telegram
          el-col(:xs="12", :sm="4", :md="4", :style="{marginBottom: '16px'}")
            h5
              img.rocket(:src="require('@/assets/svg/foguete.svg')")
              |Legal
            a(href="#") Termos
            br
            a(href="#") Privacidade
            br
            a(href="#") Cookies
        .margin-top
        p.text-center Todos os direitos reservados 2020
        .margin-top
</template>

<script>
  export default {
    name: 'footer-box',
    data: () => ({
      email: ''
    }),
    methods: {
      _action (to) {
        let self = this
        self.$router.push(to)
        self._toTop()
      },
      _toTop (e) {
        let self = this
        self.$root.scrollTo(0, 1250, window.scrollY)
      },
      _validateEmail() {
        let self = this
        if (self.email == '') return
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(self.email)) {
          self.recaptcha()
        } else {
          self.$message.warning('E-mail inválido!')
        }
      },
      recaptcha () {
        let self = this
        self.$recaptcha('email')
        .then((token) => {
          self.sendMail()
        })
        .catch(err => {
          self.$message.warning('Captcha inválido!')
        })
      },
      sendMail () {
        let self = this, Body = 'Copie o link ==> https://validar-email.agencia2ed.com.br/&tags=site,footer',
          loading = this.$loading({
            lock: true,
            text: 'aguarde',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0,0,0.7)'
          })
        Email.send({
          SecureToken : '4a47df8a-a6ed-47a9-9e05-20a338d7883b',
          To : self.email,
          From : 'agencia.2ed.oficial@gmail.com',
          Subject : 'Verificação de e-mail',
          Body
        })
        .then(
          message => {
            if (message == 'OK') {
              self.$message.success('Cheque seu e-mail, enviamos um e-mail de verificação')
              self.email = ''
            } else {
              self.$message.warning('Não foi possível enviar o e-mail, tente novamente mais tarde')
            }
            loading.close()
          }
        )
        .catch(err => {
          loading.close()
          self.$message.error('Não foi possível enviar o e-mail')
        })
      }
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  .bg-footer
    background: $c-bg-footer
  .bg-footer-mail
    background: $c-accent
    padding: 0
    margin: 0
  .img-bg
    width: 100%
    vertical-align: middle
    border-style: none
    position: absolute
    padding: 0
    margin: 0
    transform: translateY(-5px)
  .to-top
    height: 90px
    position: absolute
    border: solid 5px #F1EFF5
    border-radius: 50px !important
    font-size: $f-size*1.4 !important
    transform: translateY(-40px)
    &:hover, &:active, &:focus
      border: solid 5px #F1EFF5
      box-shadow: 0px 10px 5px 0px rgba(0,0,0,0.5)
  .to-top.white
    border-color: $c-white
  .rocket
    height: 30px
    margin-right: 16px
  h1
    color: $c-white
    margin-bottom: 32px
  h5
    font-size: $f-size
    color: $c-white
  p
    color: $c-white
    font-size: $f-size*.75
  a
    color: $c-grey
    &:hover
      color: $c-white
  .custom-field
    padding: 0 32px
    width: calc(100% - 64px)
    height: 4rem
    border-radius: 50rem
    outline: none !important
    border: solid 0
    text-rendering: auto
    font-size: $f-size
  .footer-btn
    position: absolute
    right: 5px
    top: 5px
    bottom: 5px
    @media (max-width: 767px)
      width: 100%
      position: relative
      right: 0
  .box-field
    width: 100%
    position: relative
  .logo
    height: 50px
    margin-bottom: 16px
</style>